module.exports = __webpack_public_path__ + "static/media/alensa2.e921c1b4.jpg";